import React, { useEffect, useState } from 'react';

const SplashScreen = () => {
  const [fading, setFading] = useState(false);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setFading(true), 1900);
    const t2 = setTimeout(() => setGone(true), 2500);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  if (gone) return null;

  return (
    <div
      data-testid="splash-screen"
      className={`fixed inset-0 z-[200] flex flex-col items-center justify-center bg-fire-ink transition-opacity duration-500 ${
        fading ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      {/* Ambient ember glow */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full opacity-40 blur-3xl pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(217,117,36,0.45), transparent 60%)' }}
      />
      <div className="relative animate-fade-up flex flex-col items-center">
        <div className="rounded-3xl overflow-hidden bg-fire-cream p-5 md:p-6 shadow-2xl w-[260px] md:w-[340px]">
          <img src="/brand/logo-flame.jpg" alt="After the Fire — Still Covered" className="w-full h-auto" />
        </div>
        {/* Loading shimmer */}
        <div className="mt-8 w-40 h-[3px] rounded-full bg-fire-gold/15 overflow-hidden">
          <div className="h-full w-1/2 bg-gradient-to-r from-transparent via-fire-gold to-transparent animate-splash-load" />
        </div>
        <p className="mt-4 font-marcellus tracking-[0.3em] text-fire-cream/50 text-[10px] uppercase">
          Tested by the Fire. Refined by the Flame.
        </p>
      </div>

      <style>{`
        @keyframes splash-load {
          0% { transform: translateX(-120%); }
          100% { transform: translateX(340%); }
        }
        .animate-splash-load { animation: splash-load 1.3s ease-in-out infinite; }
      `}</style>
    </div>
  );
};

export default SplashScreen;
